import {
  DEFAULT_CHAIN,
  SUPPORTED_CHAINS,
  USDT_ADDRESSES,
} from '@package/smart-wallet/constants';

export const getChainById = (chainId: number) => {
  return (
    Object.values(SUPPORTED_CHAINS).find(
      (network) => network.chain?.id === chainId,
    )?.chain ?? DEFAULT_CHAIN
  );
};

export const getSupportedChainIds = () => {
  return Object.values(SUPPORTED_CHAINS)
    .map((network) => network.chain?.id)
    .filter((id): id is number => id !== undefined);
};

export const getSupportedEVMChainIds = () => {
  return Object.values(SUPPORTED_CHAINS)
    .map((network) => network.chain?.id)
    .filter((id): id is number => id !== undefined && id !== 0);
};

export const getUSDTAddressByChainId = (chainId: number) => {
  return USDT_ADDRESSES[chainId];
};
